<template>
  <div class="expense-container">
    <h2 class="title">💸 Gestion des charges</h2>
    <p class="subtitle">Enregistre et suis toutes tes dépenses</p>

    <!-- Formulaire d'ajout -->
    <form @submit.prevent="ajouterCharge" class="form-card">
      <input
        v-model="label"
        type="text"
        class="form-control"
        placeholder="Libellé (ex : Sucre, Loyer...)"
      />
      <input
        v-model.number="amount"
        type="number"
        class="form-control"
        placeholder="Montant (MAD)"
      />
      <input
        v-model="date"
        type="date"
        class="form-control"
      />
      <button class="btn-add">Ajouter</button>
    </form>

    <!-- Liste -->
    <div v-if="charges.length" class="list-section">
      <h4 class="list-title">Liste des charges</h4>
      <ul class="expense-list">
        <li
          v-for="c in charges"
          :key="c.id"
          class="expense-item"
        >
          <div>
            <strong>{{ c.label }}</strong>
            <span class="amount">{{ c.amount }} MAD</span>
            <span v-if="c.date" class="date">📅 {{ formatDate(c.date) }}</span>
          </div>
          <button class="btn-delete" @click="supprimerCharge(c.id)">✖</button>
        </li>
      </ul>

      <p class="total">
        Total des dépenses :
        <strong>{{ totalAmount }} MAD</strong>
      </p>
    </div>

    <div v-else class="empty-state">
      <p>Aucune dépense enregistrée pour le moment.</p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Expenses",
  data() {
    return {
      label: "",
      amount: null,
      date: this.today(),
    };
  },
  computed: {
    ...mapGetters("expenses", ["all", "totalAmount"]),
    charges() {
      return this.all;
    },
  },
  methods: {
    ...mapActions("expenses", ["add", "fetch", "remove"]),
    today() {
      return new Date().toISOString().split("T")[0];
    },
    formatDate(dateStr) {
      if (!dateStr) return "";
      return new Date(dateStr).toLocaleDateString();
    },
    async ajouterCharge() {
      if (!this.label || !this.amount) return;
      await this.add({ label: this.label, amount: this.amount, date: this.date });
      this.label = "";
      this.amount = null;
      this.date = this.today();
    },
    async supprimerCharge(id) {
      await this.remove(id);
    },
  },
  created() {
    this.fetch();
  },
};
</script>

<style scoped>
.expense-container {
  background: #f8fafc;
  min-height: 100vh;
  padding: 25px 15px 60px;
  font-family: "Poppins", Avenir, Helvetica, sans-serif;
  color: #2b2b2b;
}

.title {
  font-size: 22px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 4px;
}

.subtitle {
  font-size: 14px;
  color: #6c757d;
  text-align: center;
  margin-bottom: 20px;
}

/* Formulaire */
.form-card {
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.form-control {
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 10px;
  font-size: 14px;
}

.btn-add {
  background: linear-gradient(135deg, #f6c23e, #dda20a);
  color: white;
  border: none;
  padding: 10px;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
}
.btn-add:hover {
  opacity: 0.9;
}

/* Liste */
.list-section {
  margin-top: 25px;
}
.list-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
}
.expense-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.expense-item {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  margin-bottom: 10px;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.amount {
  color: #555;
  margin-left: 5px;
  font-size: 13px;
}
.date {
  display: block;
  color: #888;
  font-size: 12px;
  margin-top: 2px;
}
.btn-delete {
  background: #f87171;
  border: none;
  color: white;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  font-weight: bold;
  cursor: pointer;
}
.btn-delete:hover {
  background: #ef4444;
}

.total {
  margin-top: 10px;
  font-weight: 600;
  text-align: right;
  color: #1e293b;
}

.empty-state {
  margin-top: 30px;
  text-align: center;
  color: #999;
  font-size: 14px;
}
</style>
